import { FormControl, FormControlLabel, Switch } from '@mui/material';
import type { ChangeEventHandler } from 'react';

interface LabeledSwitchProps {
  label: string;
  name: string;
  disabled?: boolean;
  checked?: boolean;
  onChange: ChangeEventHandler<any>;
}

const LabeledSwitch = ({ label, name, disabled, checked, onChange }: LabeledSwitchProps) => {
  return (
    <FormControl>
      <FormControlLabel
        control={<Switch name={name} checked={checked} onChange={onChange} />}
        label={label}
        disabled={disabled}
      />
    </FormControl>
  );
};

export default LabeledSwitch;
